// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/kubernetes_configuration.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { KubernetesResourceSpec } from "./kubernetes_resource_spec_pb.js";

/**
 * Shortcut configuration options that translate to expanded Kubernetes resource
 * configuration.
 *
 * @generated from message ai.h2o.deploy.KubernetesConfigurationShortcut
 */
export const KubernetesConfigurationShortcut = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.KubernetesConfigurationShortcut",
  () => [
    { no: 1, name: "kubernetes_affinity_shortcut_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kubernetes_toleration_shortcut_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Kubernetes configurable options including k8s configuration shortcut
 * and kubernetes resource specifications.
 *
 * @generated from message ai.h2o.deploy.ConfigurableKubernetesOption
 */
export const ConfigurableKubernetesOption = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ConfigurableKubernetesOption",
  () => [
    { no: 1, name: "kubernetes_configuration_shortcut", kind: "message", T: KubernetesConfigurationShortcut },
    { no: 2, name: "kubernetes_resource_spec", kind: "message", T: KubernetesResourceSpec },
  ],
);

